import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { sizes } from '../../../const/sizes';
const StyledDialogCenteredTextContainer = styled('div', {
    paddingLeft: sizes.dialogCenteredTextContainer.horizontalSpacing,
    paddingRight: sizes.dialogCenteredTextContainer.horizontalSpacing,
});
export const DialogCenteredContentContainer = ({ children, }) => (_jsx(StyledDialogCenteredTextContainer, { children: children }));
